import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Card } from '@/components/ui/card';
import { LEGAL_DOCUMENT_PATHS, type LegalDocumentCode } from '@/constants/legal';

const CLIENT_LEGAL_DOCUMENTS: { code: LegalDocumentCode; labelKey: string }[] = [
  { code: 'privacy_notice', labelKey: 'privacyNotice' },
  { code: 'client_portal_terms', labelKey: 'clientPortalTerms' },
];

export function LegalDocumentsCard() {
  const { t } = useTranslation(['clients', 'legal']);
  return (
    <Card as="section">
      <div className="flex items-center gap-2 mb-2">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name="FileText" />
        </span>
        <h2 className="text-sm font-bold text-zooindigo">
          {t('clients:portal.legalDocuments.title')}
        </h2>
      </div>
      <p className="text-sm text-zoomuted mb-3">{t('clients:portal.legalDocuments.description')}</p>
      <ul className="flex flex-col sm:flex-row gap-2 sm:gap-6">
        {CLIENT_LEGAL_DOCUMENTS.map(function renderDocumentLink(document) {
          return (
            <li key={document.code}>
              <a
                href={LEGAL_DOCUMENT_PATHS[document.code]}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 min-h-[44px] text-sm font-semibold text-zooprimary hover:text-zooindigo underline"
              >
                {t('legal:' + document.labelKey)}
                <Icon name="ExternalLink" />
              </a>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
